import { isNonProductionBuild } from '@sketch/utils'
import { addQueryParametersToUrl } from 'utils/route'
import { SsoSignInSource } from '../SsoSignInSource'

export const sourceToSsoSignInSource: { [key: string]: SsoSignInSource } = {
  sketch: 'sketch',
  cloud: 'cloud',
}

export const mapSsoStartUrl = (
  url: string,
  {
    source = 'cloud',
    from,
    ...moreParams
  }: { source?: SsoSignInSource; from?: string } & {
    [key: string]: string | undefined
  } = {}
): string => {
  const queryParameters = { source, ...moreParams }

  if (isNonProductionBuild()) {
    /**
     * The debug parameter tells the SSO service that when the sign-in flow
     * finishes it should not redirect the user back to a FE URL but just return
     * the URL in plain text.
     *
     * This makes it easier for us, devs, to use SSO from localhost. If not
     * present, the SSO service would redirect the browser to dev.sketch.cloud.
     */
    Object.assign(queryParameters, { debug: 'true' })
  }

  if (from) {
    Object.assign(queryParameters, { from })
  }

  return addQueryParametersToUrl(url, queryParameters)
}
